[{
        "display": "true",
        "ui_columnname": "CATReporterIMID",
        "db_columnname": "tf.catReporterIMID",
        "datatype": "String",
        "mappingkey": "catReporterIMID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Account Number",
        "db_columnname": "tf.accountNumber",
        "datatype": "String",
        "mappingkey": "accountNumber",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Name",
        "db_columnname": "tf.name",
        "datatype": "String",
        "mappingkey": "name",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Given Name",
        "db_columnname": "tf.givenName",
        "datatype": "String",
        "mappingkey": "givenName",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Generated FDID",
        "db_columnname": "tf.generatedFDID",
        "datatype": "String",
        "mappingkey": "generatedFDID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Received FDID",
        "db_columnname": "tf.receivedFDID",
        "datatype": "String",
        "mappingkey": "receivedFDID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Active",
        "db_columnname": "tf.active",
        "datatype": "String",
        "mappingkey": "active",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created User",
        "db_columnname": "tf.createdUser",
        "datatype": "String",
        "mappingkey": "createdUser",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated User",
        "db_columnname": "tf.updatedUser",
        "datatype": "String",
        "mappingkey": "updatedUser",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created Date",
        "db_columnname": "tf.createdDate",
        "datatype": "String",
        "mappingkey": "createdDate",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated Date",
        "db_columnname": "tf.updatedDate",
        "datatype": "String",
        "mappingkey": "updatedDate",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    }
]